/**
 * Send an error to Datadog RUM and Datadog Logs if available (never throws).
 *
 * Uses window globals (DD_RUM, DD_LOGS) so sparkle doesn't need to depend
 * on @datadog/browser-rum or @datadog/browser-logs.
 */
export function reportToDatadog(error, context) {
  try {
    var _ddRum$addError;
    const ddRum = window.DD_RUM;
    ddRum === null || ddRum === void 0 || (_ddRum$addError = ddRum.addError) === null || _ddRum$addError === void 0 || _ddRum$addError.call(ddRum, error, context);
  } catch (_unused) {
    // Fail-safe: Datadog may not be loaded yet.
  }
  try {
    var _ddLogs$logger, _ddLogs$logger$error;
    const ddLogs = window.DD_LOGS;
    const message = error instanceof Error ? error.message : String(error);
    ddLogs === null || ddLogs === void 0 || (_ddLogs$logger = ddLogs.logger) === null || _ddLogs$logger === void 0 || (_ddLogs$logger$error = _ddLogs$logger.error) === null || _ddLogs$logger$error === void 0 || _ddLogs$logger$error.call(_ddLogs$logger, message, context);
  } catch (_unused2) {
    // Fail-safe: Datadog Logs may not be initialized.
  }
}
//# sourceMappingURL=reportToDatadog.js.map